import React from 'react';
import _ from 'underscore';

import {HoistedTag} from 'inventory/InventoryFileConstants';
import {SchemaFieldPath} from 'schemas/fields/SchemaFieldConstants';

import HoistedTagNameCell from './HoistedTagNameCell';
import HoistedTagValueCell from './HoistedTagValueCell';

interface HoistedTagRowsProps {
  tags: Array<HoistedTag>;
  tagSchemaGraphs: Array<SchemaFieldPath>;
}

interface TagWithGraph {
  tag: HoistedTag;
  tagSchemaGraph: SchemaFieldPath;
}

export default function HoistedTagRows(props: HoistedTagRowsProps): JSX.Element {
  const tagSchemaGraphsById = _.indexBy(props.tagSchemaGraphs, 'id');
  const sortedTagsWithGraphs: Array<TagWithGraph> = _.sortBy(props.tags, 'name')
    .map((tag): TagWithGraph => ({tag, tagSchemaGraph: tagSchemaGraphsById[tag.tagSchemaGraphId]}))
    .filter((item): item is TagWithGraph => Boolean(item.tagSchemaGraph));
  return (
    <div role="list">
      {sortedTagsWithGraphs.map(({tag, tagSchemaGraph}, tagIndex) => (
        <div className="simpleDivTable-row metadata-field" key={tagIndex} role="listitem">
          <HoistedTagNameCell tag={tag} tagSchemaGraph={tagSchemaGraph} />
          <HoistedTagValueCell tag={tag} />
        </div>
      ))}
    </div>
  );
}
